module.exports = __webpack_public_path__ + "static/footer-bg-9f4c4f80a6a6bd1b72378e985dd451ab.jpg";